var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height",attrs:{"id":"app"}},[(_vm.showApp)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }